import { Option, Select } from "../select";
import { useState, useEffect, useContext } from "react";
import Dynamic from "./dynamic";
import { ApisValue } from "../contexts/apis";
import styles from "./styles.module.css";
export default function Apis({ value, onChange, params }) {
  const [_value, setValue] = useState({
    api: "",
    call: "",
    type: "",
    list: false,
    params: {},
    bodyParams: {},
  });
  const [calls, setCalls] = useState(null);
  const [dynamics, setDynamics] = useState([]);
  const [bodyParams, setBodyParams] = useState([]);
  const apis = useContext(ApisValue);

  useEffect(() => {
    if (value) {
      setValue(value);
    } else {
    }
  }, [value]);

  useEffect(() => {
    if (_value.api) {
      const { calls } = apis.find((x) => x.id === _value.api);
      setCalls(calls);
    }
  }, [_value.api]);

  const handleSelectApi = (v) => {
    const __value = { ..._value };
    __value.api = v;
    __value.call = "";

    setValue(__value);
  };

  const handleSelectCall = (e) => {
    console.log(e.target.value);
    const call = calls.find((x) => x.id === e.target.value);
    if (call) {
      const __value = { ..._value };
      __value.call = e.target.value;
      __value.type = call.schema.type;
      __value.list = call.schema.list;

      setDynamics(call.params || []);
      setBodyParams(call.bodyParams || []);
      setValue(__value);
      onChange(__value);
    }
  };

  const handleBodyParam = (value, param) => {
    const __value = { ..._value };
    __value.bodyParams[param.name] = value;
    setValue(__value);
    onChange(__value);
  };

  const handleURLParam = (value, param) => {
    const __value = { ..._value };
    __value.params[param.name] = value;
    setValue(__value);
    onChange(__value);
  };
  return (
    <div>
      <Select onChange={handleSelectApi} value={_value.api}>
        {apis.map((a) => {
          return (
            <Option key={a.name} value={a.id}>
              {a.name}
            </Option>
          );
        })}
      </Select>
      {calls && (
        <select
          style={{ marginTop: 12 }}
          onChange={handleSelectCall}
          value={_value.call}
          className={"dropdown"}
        >
          <option value="" disabled>
            select...
          </option>
          {calls.map((c) => {
            return (
              <option key={c.name} value={c.id}>
                {c.name}
              </option>
            );
          })}
        </select>
      )}
      {dynamics.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <div>URL Params</div>
          {dynamics.map((p) => {
            return (
              <ParamEditor
                key={p.name + p.index}
                onChange={(value) => handleURLParam(value, p)}
                value={_value.bodyParams[p.name]}
                param={p}
              />
            );
          })}
        </div>
      )}
      {bodyParams.length > 0 && (
        <div style={{ marginTop: 12 }}>
          <div>Body Params</div>
          {bodyParams.map((p) => {
            return (
              <ParamEditor
                key={p.name + p.index}
                onChange={(value) => handleBodyParam(value, p)}
                value={_value.bodyParams[p.name]}
                param={p}
              />
            );
          })}
        </div>
      )}
    </div>
  );
}

const ParamEditor = ({ param, value, onChange }) => {
  return (
    <div className={styles.apiParam}>
      <div>{param.name}</div>
      <Dynamic
        value={value}
        onChange={onChange}
        params={{ type: "Text", list: false }}
        sources={[]}
      />
    </div>
  );
};
